module.exports = __webpack_public_path__ + "img/cta_1.63b37d8d.png";